<footer class="footer">
    <div class="container-sm">
        <div class="display-lg">
            <div class="row">
                <div class="col-lg-4 footer-col">
                    <a class="nav-link text-white" routerLink="/acerca-de">{{"footer.about" |translate| uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/historia">{{ "footer.history" |translate |
                        uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/marco-politico-juridico">
                        {{ "footer.political_legal_framework" | translate|uppercase}}
                    </a>
                    <a class="nav-link text-white" routerLink="/resoluciones">{{ "footer.resolutions"|translate |
                        uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/agenda">{{ "footer.diary_of_PARLACEN" |translate|
                        uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/parlacen-tv">{{ "footer.PARLACEN_TV" | translate|
                        uppercase}}</a>
                   <!--  <a class="nav-link text-white" routerLink="/boletin-parlamentario">
                        {{ "footer.parliamentary_bulletin" | translate| uppercase}}
                    </a> -->
                    <a class="nav-link text-white" routerLink="/noticias">
                        {{ "footer.newspaper" | translate| uppercase}}
                    </a>
                    <a class="nav-link text-white" routerLink="/eurolat">
                        {{ "footer.eurolat" | translate| uppercase}}
                    </a>
                </div>
                <div class="col-lg-5 footer-col">
                    <a class="nav-link text-white" routerLink="/inicio">{{ "footer.organization_chart" |translate |
                        uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/asamblea-plenaria">
                        {{ "footer.parliamentary_assembly" |translate | uppercase}}
                    </a>
                    <a class="nav-link text-white" routerLink="/informes-plenaria">{{ "footer.reports_proceedings"
                        |translate | uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/junta-directiva">{{ "footer.board_of_directors"
                        |translate | uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/comisiones">{{ "footer.work_comissions" |translate |
                        uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/bloque-mujeres-parlamentarias">
                        {{ "footer.bloc_of_women_parliamentarians" |translate | uppercase}}
                    </a>
                    <a class="nav-link text-white" routerLink="/grupos-parlamentarios">
                        {{ "footer.parliamentary_groups" |translate | uppercase}}
                    </a>
                    <a class="nav-link text-white" routerLink="/diputados">{{ "footer.deputies" |translate |
                        uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/contacto">{{ "footer.contact_us" |translate |
                        uppercase}}</a>
                </div>
                <div class="col-lg-3 footer-col">
                    <div class="contacto mt-1 pl-3">
                        <div>
                            <strong>{{ "footer.follow_us" |translate | uppercase}}</strong>
                            <strong>
                                <div id="icons-follow-us">
                                    <div id="facebook-icon">
                                        <a href="https://www.facebook.com/parlacen/" target="_blank"
                                            rel="noopener noreferrer" style="height: 40px;">
                                            <svg class="Trazado_27" viewBox="1482.373 9541.031 7.889 13.516">
                                                <path id="Trazado_27"
                                                    d="M 1487.630981445312 9544.33984375 L 1487.630981445312 9546.2978515625 L 1490.092041015625 9546.2880859375 L 1490.092041015625 9548.7578125 L 1487.630981445312 9548.654296875 L 1487.630981445312 9554.546875 L 1484.56298828125 9554.546875 L 1484.56298828125 9548.654296875 L 1482.373046875 9548.654296875 L 1482.373046875 9546.2978515625 L 1484.56298828125 9546.2978515625 L 1484.56298828125 9544.1083984375 C 1484.56298828125 9542.1162109375 1486.098999023438 9541.03125 1488.078002929688 9541.03125 C 1489.030029296875 9541.03125 1489.79296875 9541.0947265625 1490.261962890625 9541.125 L 1490.261962890625 9543.5478515625 L 1488.447998046875 9543.5478515625 C 1487.369995117188 9543.5478515625 1487.630981445312 9543.66796875 1487.630981445312 9544.33984375 Z">
                                                </path>
                                            </svg>
                                        </a>
                                    </div>
                                    <a href="https://twitter.com/parlacen?lang=en" target="_blank"
                                        style="padding: 0; margin: -3px;" rel="noopener noreferrer">
                                        <svg class="twitter-icon" viewBox="1522.054 9540.772 18.386 15.321">
                                            <path id="Trazado_28"
                                                d="M 1538.56005859375 9544.5869140625 C 1538.56298828125 9544.75390625 1538.568969726562 9544.9208984375 1538.568969726562 9545.087890625 C 1538.568969726562 9550.19921875 1534.77294921875 9556.09375 1527.836059570312 9556.09375 C 1525.70703125 9556.09375 1523.723999023438 9555.453125 1522.053955078125 9554.357421875 C 1522.348999023438 9554.3896484375 1522.649047851562 9554.4111328125 1522.953002929688 9554.4111328125 C 1524.719970703125 9554.4111328125 1526.350952148438 9553.7919921875 1527.641967773438 9552.755859375 C 1525.987060546875 9552.72265625 1524.598999023438 9551.6083984375 1524.115966796875 9550.072265625 C 1524.347045898438 9550.1171875 1524.583984375 9550.140625 1524.823974609375 9550.140625 C 1525.172973632812 9550.140625 1525.600952148438 9550.08984375 1525.9169921875 9550.001953125 C 1524.18896484375 9549.6494140625 1522.983032226562 9548.08203125 1522.983032226562 9546.2080078125 L 1522.983032226562 9546.1630859375 C 1523.590942382812 9546.4482421875 1523.982055664062 9546.6240234375 1524.598999023438 9546.646484375 C 1523.5849609375 9545.953125 1522.8740234375 9544.765625 1522.8740234375 9543.4228515625 C 1522.8740234375 9542.71875 1523.035034179688 9542.05078125 1523.359985351562 9541.48046875 C 1525.222045898438 9543.8212890625 1527.988037109375 9545.3583984375 1531.1259765625 9545.5224609375 C 1531.056030273438 9545.2373046875 1531.01904296875 9544.9423828125 1531.01904296875 9544.640625 C 1531.01904296875 9542.505859375 1532.704956054688 9540.7724609375 1534.787963867188 9540.7724609375 C 1535.873046875 9540.7724609375 1536.85302734375 9541.240234375 1537.5400390625 9541.990234375 C 1538.399047851562 9541.8203125 1539.203979492188 9541.5009765625 1539.93603515625 9541.0537109375 C 1539.654052734375 9541.9560546875 1539.055053710938 9542.71875 1538.275024414062 9543.193359375 C 1539.0400390625 9543.1005859375 1539.765991210938 9542.89453125 1540.43994140625 9542.5849609375 C 1539.93896484375 9543.3603515625 1539.295043945312 9544.04296875 1538.56005859375 9544.5869140625 Z">
                                            </path>
                                        </svg>
                                    </a>
                                    <div id="youtube-icon">
                                        <a href="https://www.youtube.com/user/SedeParlacen" target="_blank"
                                            rel="noopener noreferrer">
                                            <svg class="Rectngulo_62">
                                                <rect id="Rectngulo_62" rx="3.7262465953826904" ry="3.7262465953826904"
                                                    x="0" y="0" width="19.078" height="16.257">
                                                </rect>
                                            </svg>
                                            <svg class="Polgono_1" viewBox="0 0 7 6">
                                                <path id="Polgono_1" d="M 3.499999761581421 0 L 7 6 L 0 6 Z">
                                                </path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </strong>
                        </div>
                        <div class="mt-5">
                            <strong>{{ "footer.contact_us" |translate | uppercase}}</strong>
                            <strong>
                                <div id="contact-icons">
                                    <div id="Grupo_206">
                                        <a class="nav-link text-white" routerLink="/contacto">
                                            <svg class="Rectngulo_62_ka">
                                                <rect id="Rectngulo_62_ka" rx="3.7262465953826904"
                                                    ry="3.7262465953826904" x="0" y="0" width="19.078" height="16.257">
                                                </rect>
                                            </svg>
                                            <svg class="Trazado_26" viewBox="1569.518 9542.024 19.078 8.169">
                                                <path id="Trazado_26"
                                                    d="M 1588.596435546875 9542.4853515625 L 1578.993774414062 9550.193359375 L 1569.518432617188 9542.0244140625">
                                                </path>
                                            </svg>
                                            <svg class="Lnea_35" viewBox="0 0 6.13 7.178">
                                                <path id="Lnea_35" d="M 0 0 L 6.129716396331787 7.178355693817139">
                                                </path>
                                            </svg>
                                            <svg class="Lnea_36" viewBox="0 0 6.288 6.943">
                                                <path id="Lnea_36" d="M 0 6.942832469940186 L 6.287618637084961 0">
                                                </path>
                                            </svg>
                                        </a>

                                    </div>
                                    <a href="tel:+50224244600." style="height: 25px;">
                                        <svg class="Trazado_170" viewBox="487.2 3119.573 19.56 19.69">
                                            <path id="Trazado_170"
                                                d="M 506.760009765625 3134.75 L 502.9469909667969 3130.93701171875 C 502.9469909667969 3130.93701171875 500.9660034179688 3130.60107421875 499.2090148925781 3132.58203125 L 493.8630065917969 3127.236083984375 C 493.8630065917969 3127.236083984375 496.1059875488281 3125.366943359375 495.5450134277344 3123.535888671875 L 491.5830078125 3119.572998046875 C 491.5830078125 3119.572998046875 486.4660034179688 3119.7958984375 487.2900085449219 3124.486083984375 C 487.5320129394531 3125.866943359375 488.2250061035156 3127.1298828125 489.2160034179688 3128.1220703125 L 498.3059997558594 3137.2119140625 C 499.1579895019531 3138.06298828125 500.2109985351562 3138.693115234375 501.3739929199219 3139.0048828125 C 503.5429992675781 3139.587890625 506.6390075683594 3139.56494140625 506.760009765625 3134.75 Z">
                                            </path>
                                        </svg>
                                    </a>
                                </div>
                            </strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3"></div>
                <div class="col-lg-6">
                    <div class="mt-5 d-flex text-center justify-content-center">
                        <a class="nav-link text-white" href="/sitemap" >
                            {{ "footer.sitemap" | translate | uppercase }}
                        </a>
                        <a class="mt-2 text-white"> | </a>
                        <a class="nav-link text-white" routerLink="/other-parliaments">
                            {{ "footer.other_parliaments" | translate | uppercase }}
                        </a>
                        <a class="mt-2 text-white"> | </a>
                        <a class="nav-link text-white" href="https://admin-parlacen-int.web.app/iniciar-sesion"
                            target="_blank" rel="noopener noreferrer">
                            {{ "footer.login" | translate | uppercase }}
                        </a>
                        <a class="mt-2 text-white"> | </a>
                        <a class="nav-link text-white" href="https://www.office.com/" target="_blank"
                            rel="noopener noreferrer">
                            {{ "footer.email" | translate | uppercase}}
                        </a>
                        <a class="mt-2 text-white"> | </a>
                        <a class="nav-link text-white" routerLink="/contacto">
                            {{ "footer.contact_us" |translate | uppercase}}
                        </a>
                    </div>
                </div>
                <div class="col-sm-3"></div>
            </div>
        </div>
        <div class="display-sm">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <a class="nav-link text-white" routerLink="/inicio">{{ "footer.home" | translate | uppercase}}</a>
                    <a class="nav-link text-white" routerLink="/acerca-de">
                        {{ "footer.about" | translate | uppercase}}
                    </a>
                    <a class="nav-link text-white" routerLink="/resolutions">
                        {{ "footer.resolutions"|translate | uppercase }}
                    </a>
                    <a class="nav-link text-white" routerLink="/agenda">
                        {{ "footer.diary_of_PARLACEN" | translate | uppercase }}
                    </a>
                    <a class="nav-link text-white" routerLink="/inicio">{{ "Multimedia" | uppercase }}</a>
                    <a class="nav-link text-white" routerLink="/noticias">{{ "footer.news" | translate| uppercase }}</a>
                    <a class="nav-link text-white" routerLink="/junta-directiva">
                        {{ "footer.organization_chart" |translate| uppercase}}
                    </a>
                    <a class="nav-link text-white" routerLink="/contacto">
                        {{ "footer.contact_us" |translate | uppercase}}
                    </a>
                    <div class="my-5 divider">
                        <hr class="w-50" />
                    </div>
                    <a class="nav-link text-white" href="/sitemap">
                        {{ "footer.sitemap" | translate | uppercase }}
                    </a>
                    <a class="nav-link text-white" routerLink="/other-parliaments">
                        {{ "footer.other_parliaments" | translate | uppercase }}
                    </a>
                    <a class="nav-link text-white" routerLink="/iniciar-sesion">
                        {{ "footer.login" | translate | uppercase }}
                    </a>
                    <a class="nav-link text-white" href="https://www.office.com/" target="_blank"
                        rel="noopener noreferrer">
                        {{ "footer.email" | translate | uppercase }}
                    </a>
                    <div class="mt-5 divider">
                        <hr class="w-50" />
                    </div>
                </div>
            </div>
        </div>
        <br><br>
        <div class="row">
            <div class="col-lg-12">
              <p class="text-center">Seleccione idioma: <br>  </p>
                  <div class="d-flex nav-item active justify-content-center languages mt-1">

                    <br>
                    <a class="nav-link " class="es text-white" (click)="switchLang('es')"> {{ " ES " }}</a>
                    <a class="px-1 text-white"> | </a>
                    <a class="nav-link text-white" class="en text-white" (click)="switchLang('en')">{{ " EN" }}</a>
                </div>
            </div>
            <div class="col-sm-3"></div>
            <div class="col-sm-6">
                <div class="mt-5 copyright">
                    {{ "footer.copyright_1" |translate }}<br>
                    {{ "footer.copyright_2" |translate }}
                    <a href="https://parlacen.int/" target="blank" class="text-white">PARLACEN</a>
                </div>
            </div>
            <div class="col-sm-3"></div>
        </div>
    </div>
</footer>
